import { hsmBackendClient } from './client';
import { AddOnPurchase, IControllerResponse } from './types';

/**
 * Cancels a single add-on purchase / package (status → cancelled). Hits
 * `POST /company/{companyId}/add-on-purchase/{addOnId}/cancel` and returns the
 * updated `AddOnPurchase`. Only `active` add-ons can be cancelled.
 *
 * @param companyId Target company id.
 * @param addOnId   The add-on purchase id to cancel.
 */
export async function cancelAddOnPurchase(
  companyId: string,
  addOnId: number
): Promise<AddOnPurchase> {
  const response = await hsmBackendClient.post<
    IControllerResponse<AddOnPurchase>
  >(
    `/company/${encodeURIComponent(companyId)}/add-on-purchase/${addOnId}/cancel`
  );

  if (!response.data.result) {
    throw new Error(
      response.data.message ?? 'Respuesta del backend sin result'
    );
  }
  return response.data.result;
}
